import {
  onCLS,
  onFCP,
  onINP,
  onLCP,
  onTTFB,
  type Metric,
} from "web-vitals";

import { trackEvent } from "@/lib/analytics";

let hasRegistered = false;

/**
 * Level 2 RUM baseline.
 *
 * Web Vitals are sent through the existing consent-gated Rollbar telemetry
 * path (`trackEvent`). This keeps diagnostics opt-in, avoids a second analytics
 * vendor, and gives us audit evidence for LCP/INP/CLS/FCP/TTFB until a proper
 * warehouse/dashboard exists.
 */
export function registerWebVitals(): void {
  if (hasRegistered || typeof window === "undefined") return;
  hasRegistered = true;

  const report = (metric: Metric) => {
    trackEvent("web_vital_recorded", {
      metric_name: metric.name,
      metric_id: metric.id,
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      navigation_type: metric.navigationType,
      path: window.location.pathname,
    });
  };

  onCLS(report);
  onFCP(report);
  onINP(report);
  onLCP(report);
  onTTFB(report);
}
